<div class="preview-area">
  <% if (patientDocument.previewUrl) { %>
    <img class="preview-image" src="<%= patientDocument.previewUrl %>" />
  <% } else { %>
    <span class="no-preview-image">No preview available</span>
  <% } %>
  <ul class="preview-toolbar" tabindex="0" aria-label="Preview Toolbar">
    <li class="toolbar-item toolbar-item--open"><a href="<%= patientDocument.previewUrl %>" target="_blank"><i class="icon"></i>Open</a></li>
    <li class="toolbar-item toolbar-item--download"><a href="<%= patientDocument.downloadUrl %>"><i class="icon"></i>Download</a></li>
    <li class="toolbar-item toolbar-item--print"><span tabindex=0 role="button" data-patient-document-viewer-behaviour="print"><i class="icon"></i>Print</span></li>
  </div>
</div>
